import React, { useEffect } from 'react';
import { Col, Grid, Image, Row } from 'react-bootstrap';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import {
  applyBrandSettings,
  CUSTOM_DEFAULT_BRAND_COLOR,
  CUSTOM_DEFAULT_FONT,
} from '../../containers/change-insights/utils/index.jsx';

const SurveyCompleteForm = (props) => {
  const {
    handleSubmit,
    survey,
    organization,
    disabled,
    token,
    isPreviewTemplate,
  } = props;
  const surveySettings = {
    // mode: 'display',
  };

  const surveyModel = new Model({ ...survey.surveyJson, ...surveySettings });
  surveyModel.showTitle = false;
  surveyModel.showCompletedPage = false;

  const handleClickSend = async () => {
    const validateResponse = await surveyModel.validate();
    if (validateResponse) {
      handleSubmit(JSON.stringify(surveyModel.getAllValues()));
    }
  };

  surveyModel.onComplete.add(handleClickSend);

  useEffect(() => {
    if (survey?.settings) {
      const brandStyles = {
        brandColor: survey.settings.brandColor
          ? survey.settings.brandColor
          : CUSTOM_DEFAULT_BRAND_COLOR,
        fontName: survey.settings.fontName
          ? survey.settings.fontName
          : CUSTOM_DEFAULT_FONT,
      };
      applyBrandSettings(brandStyles);
    } else if (organization) {
      applyBrandSettings({
        brandColor: organization.brandColor
          ? organization.brandColor
          : CUSTOM_DEFAULT_BRAND_COLOR,
        fontName: organization.fontName
          ? organization.fontName
          : CUSTOM_DEFAULT_FONT,
      });
    } else {
      applyBrandSettings({
        brandColor: CUSTOM_DEFAULT_BRAND_COLOR,
        fontName: CUSTOM_DEFAULT_FONT,
      });
    }
  }, [survey]);

  const brandStyles = {
    fontFamily: survey.settings?.fontName
      ? survey.settings.fontName
      : organization?.fontName
        ? organization.fontName
        : CUSTOM_DEFAULT_FONT,
  };

  return (
    <Grid>
      <Row>
        <Col sm={12}>
          <div
            className={`component-xl component-bg-white component-xl-padding-vertical component-no-horizontal-padding survey-complete-container survey-form-complete ${disabled ? 'response-view' : ''} ${isPreviewTemplate || !token ? 'template-view' : ''}`}
          >
            <Row>
              <Col sm={10} smOffset={1}>
                <h2
                  style={{
                    ...brandStyles,
                    fontSize: '24px',
                    fontWeight: '600',
                  }}
                  className="m-b-14"
                >
                  {surveyModel.title}
                </h2>
                <p style={brandStyles}>{surveyModel.description}</p>
                {surveyModel ? <Survey model={surveyModel} /> : null}
                <div className="flex center-block flex-align-center flex-center m-t-16">
                  <span className="sentiment m-r-8">Powered by</span>
                  <a href="/" target="_blank">
                    <Image
                      alt="ChangeSync Logo"
                      src="/static/images/logo.svg"
                      style={{ width: '120px' }}
                      responsive
                    />
                  </a>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default SurveyCompleteForm;
